import { createMultiStyleConfigHelpers } from '@chakra-ui/react';

import { chakraDefaultFocusStyles, textStyle } from '../../../themeConstants';

const helpers = createMultiStyleConfigHelpers(['accordion', 'item', 'button', 'panel']);

const Accordion = helpers.defineMultiStyleConfig({
  baseStyle: {
    root: {
      mb: 8,
    },
    accordion: {
      flexDir: 'column',
      border: '1px',
      borderColor: 'border.lightGrey',
      px: 6,
      py: 8,
      bgColor: 'background.white',
      boxShadow: 'default',
    },
    item: {
      border: 0,
    },
    button: {
      p: 0,
      ...textStyle.sizeLTight,
      textAlign: 'left',
      color: 'brand.default',
      _focus: {
        ...chakraDefaultFocusStyles,
      },
      _hover: {
        color: 'text.primary',
        backgroundColor: 'inherit',
      },
    },
    panel: {
      position: 'relative',
      pt: 16,
      px: 8,
      pb: 4,
      _before: {
        content: `''`,
        position: 'absolute',
        top: '2rem',
        right: '0',
        left: '2rem',
        height: '1px',
        backgroundColor: 'background.darkGrey',
      },
    },
  },
});

export default Accordion;
